import { globalUiAction } from "./action"

const initialState = {
  isLoading: false,
  onSubmited: false,
  modal: null,
  langCode: "tw",
  showScanGo: true,
}

export function globalUiReducer(state = initialState, action) {
  switch (action.type) {
    case globalUiAction.SET_GLOBAL_UI: {
      return Object.assign({}, state, action.payload)
    }

    default:
      return state
  }
}
